import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HttpClientModule} from "@angular/common/http";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatStepperModule,
    MatTabsModule,
    MatToolbarModule
} from "@angular/material";
import {TranslateModule} from "@ngx-translate/core";

import {kanCommonModule} from "../common/module";
import {kanServiceModule} from "../services/module";

import {kanUsers} from "./components/user/users/component";
import {kanUserList} from './components/user/list/component';
import {kanUserDogs} from "./components/user/dogs/component";
import {kanUserServices} from "./components/user/services/component";
import {kanDogList} from "./components/dog/list/component";
import {kanDogListItem} from "./components/dog/list-item/component";
import {kanUser} from "./components/user/user/component";
import {kanDog} from "./components/dog/dog/component";
import {kanDogs} from "./components/dog/dogs/component";
import {kanUserListItem} from "./components/user/list-item/component";
import {kanDogServices} from "./components/dog/services/component";
import {kanUserNotes} from "./components/user/notes/component";
import {kanDogNotes} from "./components/dog/notes/component";
import {kanServices} from "./components/service/services/component";

// dialogs components
import {kanUserDialog} from "./dialogs/user-dialog/component";
import {kanServiceLogDialog} from "./dialogs/service-log-dialog/component";
import {kanUserBundleDialog} from "./dialogs/user-bundle-dialog/component";
import {kanDogDialog} from "./dialogs/dog-dialog/component";
import {kanMembershipDialog} from "./dialogs/membership-dialog/component";
import {kanNoteDialog} from "./dialogs/note-dialog/component";
import {kanServiceDialog} from "./dialogs/service-dialog/component";
import {kanFileLogDialog} from "./dialogs/file-log-dialog/component";
import {kanDogFiles} from "./components/dog/files/component";
import {kanUserFiles} from "./components/user/files/component";
import {kanPartners} from "./components/partner/partners/component";
import {kanPartnerList} from "./components/partner/list/component";
import {kanPartnerListItem} from "./components/partner/list-item/component";
import {kanPartnerTypeDialog} from "./dialogs/partner-type-dialog/component";
import {kanPartnerDialog} from "./dialogs/partner-dialog/component";
import {kanServiceList} from "./components/service/list/component";
import {kanServiceListItem} from "./components/service/list-item/component";
import {CKEditorModule} from "ng2-ckeditor";
import {kanTerms} from "./components/term/terms/component";
import {kanTermList} from "./components/term/list/component";
import {kanTermListItem} from "./components/term/list-item/component";
import {kanTermDialog} from "./dialogs/term-dialog/component";
import {kanPartnerTypes} from "./components/partner-type/partner-types/component";
import {kanPartnerTypeList} from "./components/partner-type/list/component";
import {kanPartnerTypeListItem} from "./components/partner-type/list-item/component";
import {kanContractDialog} from "./dialogs/contract-dialog/component";
import {kanNotes} from "./components/notes/notes/component";
import {kanNotesList} from "./components/notes/list/component";
import {kanNotesListItem} from "./components/notes/list-item/component";
import {kanRenewal} from "./components/dog/renewal/component";
import {kanSreviceLogs} from "./components/service-logs/service-logs/component";
import {kanServiceLogsList} from "./components/service-logs/list/component";
import {kanServiceLogsListItem} from "./components/service-logs/list-item/component";

@NgModule({
    declarations: [
        kanUsers,
        kanUserList,
        kanUserListItem,
        kanUserDogs,
        kanUserServices,
        kanUserNotes,
        kanUserFiles,
        kanDogs,
        kanDogList,
        kanDogListItem,
        kanDogServices,
        kanDogNotes,
        kanDogFiles,
        kanRenewal,
        kanPartners,
        kanPartnerList,
        kanPartnerListItem,
        kanNotes,
        kanNotesList,
        kanNotesListItem,
        kanSreviceLogs,
        kanServiceLogsList,
        kanServiceLogsListItem,
        kanUserDialog,
        kanDogDialog,
        kanNoteDialog,
        kanServiceDialog,
        kanServiceLogDialog,
        kanUserBundleDialog,
        kanMembershipDialog,
        kanFileLogDialog,
        kanPartnerDialog,
        kanUser,
        kanDog,
        kanServices,
        kanServiceList,
        kanServiceListItem,
        kanPartnerTypes,
        kanPartnerTypeList,
        kanPartnerTypeListItem,
        kanPartnerTypeDialog,
        kanTerms,
        kanTermList,
        kanTermListItem,
        kanTermDialog,
        kanContractDialog
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        TranslateModule,
        MatButtonModule,
        MatIconModule,
        MatExpansionModule,
        MatDialogModule,
        MatInputModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatCheckboxModule,
        MatSelectModule,
        MatToolbarModule,
        MatAutocompleteModule,
        MatStepperModule,
        MatTabsModule,
        MatMenuModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        CKEditorModule,
        kanCommonModule,
        kanServiceModule
    ],
    entryComponents: [
        kanUserDialog,
        kanDogDialog,
        kanNoteDialog,
        kanServiceDialog,
        kanServiceLogDialog,
        kanUserBundleDialog,
        kanMembershipDialog,
        kanFileLogDialog,
        kanPartnerDialog,
        kanPartnerTypeDialog,
        kanTermDialog,
        kanContractDialog
    ],
    exports: [
        kanUsers,
        kanDogs,
        kanRenewal,
        kanPartners,
        kanNotes,
        kanSreviceLogs,
        kanUser,
        kanDog,
        kanServices,
        kanPartnerTypes,
        kanTerms
    ],
    providers: [],
    bootstrap: []
})
export class kanAdminModule {
}



// WEBPACK FOOTER //
// ./src/modules/admin/module.ts